export default __webpack_public_path__ + "img/ced9c059f5e81dbafe3b947abf4d7616.svg";